import { QueryClient } from "@tanstack/query-core";
import type { AxiosError } from "axios";
import { cache } from "react";
import { toast } from "sonner";

import type { BackendApiErrorResponse } from "../types/backend-api-response.type";

export const onMutationError = (
  error: Error,
  variables: void,
  context: unknown,
) => {
  console.error("onMutationError", error, variables, context);
};

export const onMutationErrorWithToast = (
  error: Error,
  variables: void,
  context: unknown,
) => {
  const err = error as AxiosError<BackendApiErrorResponse>;
  let message = "Unhealthy situation! Please notify the founders!";
  if (err.response) {
    message = err.response.data.message;
  }
  toast.error(message);
};

export const getQueryClient = cache(() => new QueryClient());
